import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-heart-line text-lg"></i>
              </span>
              <span className="text-lg font-heading font-semibold text-foreground-900">
                女仆不只是工作
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed max-w-md">
              探索女仆文化背后的情感连接、角色认同与生活方式。
              用深度内容重新定义女仆文化的多元价值，
              为每一位热爱女仆文化的人提供独特的阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              分类浏览
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about#testimonials"
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  用户口碑
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  回到首页
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 女仆不只是工作 编辑部。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer"
              aria-label="微博"
            >
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer"
              aria-label="B站"
            >
              <i className="ri-bilibili-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-600 hover:bg-primary-100 transition-colors cursor-pointer"
              aria-label="微信公众号"
            >
              <i className="ri-wechat-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}